/**
 * Fades and lifts sections and grid tiles into view as they scroll into the viewport.
 * Elements already visible on load are revealed immediately (no flash-of-hidden-content).
 * Skips entirely for reduced-motion users, the theme editor, and browsers without
 * IntersectionObserver — in all of those cases the CSS default (fully visible) stands.
 */

const SELECTOR = '#MainContent .shopify-section, #MainContent .group-block';
const REVEAL_CLASS = 'is-revealed';
const READY_CLASS = 'js-scroll-reveal';

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

if (!prefersReducedMotion && !isDesignMode && 'IntersectionObserver' in window) {
  const elements = document.querySelectorAll(SELECTOR);

  if (elements.length > 0) {
    document.documentElement.classList.add(READY_CLASS);

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add(REVEAL_CLASS);
            obs.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    for (const element of elements) {
      const rect = element.getBoundingClientRect();
      const alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (alreadyVisible) {
        element.classList.add(REVEAL_CLASS);
      } else {
        observer.observe(element);
      }
    }
  }
}
